import styled from "styled-components";

const SessionWrapper = styled.div`
    padding:1rem;
    background:#f8f3e7;
    border-radius:15px;
    margin-bottom: 1rem;
    p {
        margin:0
    }
`;

export { SessionWrapper };
